import React from "react";
import { RWebShare } from "react-web-share";
import { GoShare } from "react-icons/go";

const ShareButton = (props) => {
  const { title, text, url } = props;

  return (
    <RWebShare
      data={{
        text: text,
        title: title,
        url: url,
      }}
    >
      <GoShare className="hover:text-blue-500 text-2xl ml-3 cursor-pointer" />
    </RWebShare>
  );
};
export default ShareButton;
